const About =()=>import(/* webpackChunkName: "js/home" */'../../views/landing/About');
const Login =()=>import(/* webpackChunkName: "js/home" */'../../views/landing/Login');
const Nominations =()=>import(/* webpackChunkName: "js/home" */'../../views/landing/Nominations');
const MembershipCheck =()=>import(/* webpackChunkName: "js/home" */'../../views/landing/MembershipCheckRegister');
// const ForgotPassword =()=>import(/* webpackChunkName: "js/home" */'../views/landing/ForgotPassword');
// const ChangePassword =()=>import(/* webpackChunkName: "js/home" */'../views/landing/ChangePassword');
// const ColdChainSolutions =()=>import(/* webpackChunkName: "js/home" */'../views/landing/ColdChainSolutions');
export default [
    {
        path:"/",
        component:About,
        name:"About-Us",
        meta: {
            title: 'Home Page - MoffIoT',
            metaTags: [
                {
                    name: 'description',
                    content: 'This is the home page'
                }
            ]
        }
    },
    {
        path:"/login",
        component:Login,
        name:"Login",
        meta: {
            title: 'Login Page - Get Started',
            metaTags: [
                {
                    name: 'description',
                    content: 'This is the login dashboard'
                }
            ]
        }
    },
    {
        path:"/nominations",
        component:Nominations,
        name:"Nominations",
        meta: {
            title: 'Nominations Page - Get Started',
            metaTags: [
                {
                    name: 'description',
                    content: 'This is the login dashboard'
                }
            ]
        }
    },
    {
        path:"/membership-check/:type",
        component:MembershipCheck,
        name:"MembershipCheck",
        meta: {
            title: 'Nominations Page - Get Started',
            metaTags: [
                {
                    name: 'description',
                    content: 'This is the login dashboard'
                }
            ]
        },
        props:true
    },
    // {
    //     path:"/forgot-password",
    //     component:ForgotPassword,
    //     name:"ForgotPassword",
    //     meta: {
    //         title: 'Forgot Password - Get Started',
    //         metaTags: [
    //             {
    //                 name: 'description',
    //                 content: 'This is the page to initiate password change'
    //             }
    //         ]
    //     }
    // },
    // {
    //     path:"/cold-chain-solutions",
    //     component:ColdChainSolutions,
    //     name:"ColdChainSolutions"
    // },
    // {
    //     path:"/change-password",
    //     component:ChangePassword,
    //     name:"ChangePassword",
    //     meta: {
    //         title: 'Change Password',
    //         metaTags: [
    //             {
    //                 name: 'description',
    //                 content: 'This is the page to change password'
    //             }
    //         ]
    //     }
    // }
]